import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from '../../../../shared/api.service';
import { PollItemData } from '../../../../models/PollItemData';
import { PollDashboardResponse } from '../../../../models/PollDashBoardResponse';
import { AuthenticationService } from '../../../../shared/authentication.service';
import { LicenseService } from '../../../../shared/licens.service';
import { SubsciptionData, LicenseData } from '../../../../models/LicenseData';
import { Common } from '../../../../shared/common';
import { Union } from 'src/app/pap-creation/pap-dto/pap-dto';

@Component({
  selector: 'app-union',
  templateUrl: 'union.component.html',
  styleUrls: ['./union.component.less', '../../../../shared/common.less'],
})

export class UnionComponent implements OnInit {
  @Input() union: Union;
  @Input() index: number;
  @Output() unionChange = new EventEmitter<Union>();
  @Output() deleteAtIndex = new EventEmitter<number>();

  needPap: boolean = undefined;

  constructor(
    private router: Router,
  ) {}

  removeAt(index: number) {
    this.deleteAtIndex.emit(index);
  }
  
  onUnionChange() {
    this.unionChange.emit(this.union);
  }

  goToPollCreation() {
    this.router.navigate(['/poll-creation']);
  }
  
  ngOnInit(): void {
  }
}
